/* Utility to store data */
function dataStore() { /* eslint-disable-line no-unused-vars */

 this.supported_storage = "cookie";

 /* Initializes the supported storage */
 this.initialize = function() {
  // local storage
  try {
   if(localStorage) {
    this.supported_storage = 'localstore';
    return;
   }
  }
  catch(error) {
   // TODO: console.log("getSupportedStorage - localStorage does not work");
  }
  //cookies
  try {
   if(document.cookie) {
    this.supported_storage = 'cookie';
   }
  }
  catch(error) {
   // TODO: console.log("getSupportedStorage - exception - cookie does not work");
  }
 };

 /* Stores a cookie */
 this.setCookie = function(c_name, value, exdays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays*20);
  var c_value = escape(value) + ((exdays==null) ? "" : "; expires="+exdate.toUTCString());
  document.cookie = c_name + "=" + c_value;
 };

 /* Fetches a cookie */
 this.getCookie = function(c_name) {
  var c_value = document.cookie;
  var c_start = c_value.indexOf(" " + c_name + "=");
  if (c_start == -1) {
   c_start = c_value.indexOf(c_name + "=");
  }
  if (c_start == -1) {
   c_value = "";
  }
  else {
   c_start = c_value.indexOf("=", c_start) + 1;
   var c_end = c_value.indexOf(";", c_start);
   if(c_end == -1) {
    c_end = c_value.length;
   }
   c_value = unescape(c_value.substring(c_start,c_end));
  }

  return c_value;
 };

 /* Stores local data */
 this.storeLocalData = function(key, value) {
  if(this.supported_storage == 'localstore')
   localStorage[key]= value;
  else if(this.supported_storage == 'cookie')
   this.setCookie(key,value,365);
 };

 /* Fetches local data */
 this.getLocalData = function(key, defaultValue) {
  var value = '';
  if(this.supported_storage == 'localstore') {
   if(localStorage[key]) {
    value = localStorage[key];
   }
  }
  else if(this.supported_storage == 'cookie')
   value = this.getCookie(key);

  if(value == '' || value == null)
   value = defaultValue;

  return value;
 };

 /* Clears local storage/cookies */
 this.clear = function() {
  if(this.supported_storage == 'localstore') {
   localStorage.clear();
  }
  else if(this.supported_storage == 'cookie') {
   var cookies = document.cookie.split(";");

   for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
   }
  }
 };
}
